import { apiRequest } from './apiClient';

function toQuery(filters = {}) {
  const params = new URLSearchParams();

  if (filters.classId) {
    params.set('classId', filters.classId);
  }

  if (filters.classSubjectId) {
    params.set('classSubjectId', filters.classSubjectId);
  }

  if (filters.startDate) {
    params.set('startDate', filters.startDate);
  }

  if (filters.endDate) {
    params.set('endDate', filters.endDate);
  }

  const query = params.toString();
  return query ? `?${query}` : '';
}

const emptyReport = {
  startDate: null,
  endDate: null,
  totalRecords: 0,
  records: [],
};

export async function getStudentLevels(filters = {}) {
  const response = await apiRequest(`/student/levels${toQuery(filters)}`);

  return (
    response.data || {
      ...emptyReport,
      levelCounts: [],
    }
  );
}

export async function getStudentDisciplines(filters = {}) {
  const response = await apiRequest(`/student/disciplines${toQuery(filters)}`);

  return (
    response.data || {
      ...emptyReport,
      disciplineCounts: [],
    }
  );
}
